import moment from 'moment';

class Helper {
    formatStatus(value) {
        let result = {};
        switch(value) {
            case 0: {
                result.text = "Chờ duyệt";
                result.color = "cyan"
                break;
            }
            case 1: {
                result.text = "Đã duyệt"
                result.color = "green"
                break;
            }
            case 2: {
                result.text = "Từ chối"
                result.color = "error"
                break;
            }
            
            case "NEW": {
                result.text = "Mới"
                result.color = "primary"
                break;
            }
            case "PEND": {
                result.text = "Chờ"
                result.color = "warning"
                break;
            }
            case "PASS": {
                result.text = "Đạt"
                result.color = "success"
                break;
            }
            case "FAIL": {
                result.text = "Loại"
                result.color = "error"
                break;
            }
            
            case true: {
                result.text = "Xác nhận"
                result.color = "success"
                break;
            }
            case false: {
                result.text = "Chưa xác nhận"
                result.color = "error"
                break;
            }
            default:{
                result.text = "N/A"
                break;
            }
        }
        return result;
    }
    
    formatDate(val){
        return moment(val).format("YYYY-MM-DD")
    }

    getGeo() {
        return new Promise((resolve, reject) => {
          if (!navigator.geolocation) {
            reject("Geolocation not supported");
          }
      
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const result = {
                latitude: position.coords.latitude,
                longitude: position.coords.longitude
              };
              console.log("Latitude:", result.latitude);
              console.log("Longitude:", result.longitude);
              resolve(result);
            },
            (error) => {
              console.error("Error getting location:", error);
              reject(error);
            }
          );
        });
      }
}

export default new Helper();